<div class="copilot-more-wizard-options-tile-wrapper">
    <div class="copilot-more-wizard-options-tile-container"
        [style.height]="isExpiredUser ? '162px' : null"
        [style.justify-content]="!isExpiredUser ? 'center' : null"
        [class.disabled]="isExpiredUser"
        (mouseenter)="(isHovered = true)"
        (mouseleave)="(isHovered = false)">
        <app-coming-soon class="coming-soon-tooltip" [isVisible]="isHovered"/>
        <img [src]="'svg/big-plus.svg' | assetVersion" class="copilot-more-wizard-options-tile-icon">
        <div class="copilot-more-wizard-options-tile-description"> {{ description }} </div>
    </div>
    @if (isExpiredUser) {
        <div class="premium-overlay">
            <span class="text">Upgrade to unlock</span>
            <div class="icon"> <img [src]="'svg/crown.svg' | assetVersion"> </div>
        </div>
    }
</div> 